import React, { useEffect, useRef, useState } from 'react';
import { TabPanel } from "primereact/tabview";
import { api, url } from '../../../env';
import axios from 'axios';
import { InputText } from 'primereact/inputtext';
import { residualValuesCSS } from './ResidualValues.css';
import { Button } from 'primereact/button';
import { functionGetResidualValues, residualValsSubmit } from '../functions/functionsFetch';
import { useForm } from 'react-hook-form';
import { GralInput } from './gralInput/GralInput';
import { Skeleton } from 'primereact/skeleton';
import { SkeletonInput } from '../functions/utils/SkeletonInput';
import { Chip } from 'primereact/chip';



export const ResidualValues = ({ residualValsRes, setResidualValsRes, toast }) => {
    const isInitialMount = useRef(true);
    const { register, handleSubmit, setValue, watch, getValues } = useForm();
    const [loading, setLoading] = useState(false);

    const onSubmit = async (data) => {
        setLoading(true);
        let result = await residualValsSubmit(data);
        try {
            if (result?.data.status === 200) {
                toast.current.show({ severity: 'success', summary: ' Ok', detail: 'Valores residuales actualizados' });

            } else {
                toast.current.show({ severity: 'error', summary: ' Error', detail: 'Error al actualizar los valores residuales' });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error al actualizar los valores residuales' });
            console.error('Error updating fees:', error);
        }
        setLoading(false);
    };


    return (
        <section css={residualValuesCSS()}>
            <form
                className='w-full '
                onSubmit={handleSubmit(onSubmit)}
            >
                <div className='flexConteiner grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-4/5 gap-8 mx-auto'>
                    {/* <GralInput  arr={residualValsRes} register={register}  /> */}
                    {residualValsRes.length > 0 ? residualValsRes.map(({ id, percentage }, i) => (
                        <div key={id} className=' container-input  ' >
                            <p>{i + 1}</p>
                            <div>
                                <InputText
                                    className='TextInput'
                                    {...register(id.toString(), { value: percentage })} // Asegúrate de que 'id' sea un string
                                />
                                <div className='Tooltip'>

                                    <>
                                        <div className='TooltipIndividual'>
                                            <Chip style={{ background: "#34b9de", color: "#ffffff", height: "20px" }} label="Puro" />
                                        </div>
                                    </>
                                </div>
                            </div>
                        </div>
                    )) : <SkeletonInput />}
                </div>

                <div className="ButtonWithShadow">
                    {/* <Button
                        label='Continuar'
                        className='Green py-3 mt-4 W-4/5'
                        type='submit'
                    /> */}
                    <Button label="Continuar" icon="pi pi-check" loading={loading} className='Green py-3 mt-4 W-4/5' type='submit' />

                    <div className="Shadow"></div>
                </div>
            </form>
        </section>
    );
};